import request from "root/js/request";

export const getSocialBloggersSimilarExport = async ({
  account_name_hash,
  source,
  ordering,
  limit = 1000,
  offset,
  extra_fields,
}) => {
  const response = await request({
    url: `parsers/social/bloggers/similar/export/`,
    method: "post",
    params: {
      ordering,
      limit,
      offset,
      extra_fields,
      account_name_hash,
      source,
    },
    data: {
      account_name_hash,
      source,
    },
  });
  return response.data;
};
